var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import config from '../config/enviroment';
import axios from "axios";
var DataService = /** @class */ (function () {
    function DataService() {
    }
    DataService.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var obj, decodedToken, dateNow, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        obj = {
                            result: false,
                            token: '',
                            message: '',
                        };
                        if (sessionStorage.getItem('token')) {
                            obj.result = true;
                            obj.token = sessionStorage.getItem('token') || '';
                            decodedToken = parseJwt(obj.token);
                            dateNow = new Date();
                            if (decodedToken.exp > (dateNow.getTime() / 1000)) {
                                obj.message = "Token generado con éxito";
                                return [2 /*return*/, obj];
                            }
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios({
                                url: config.urlTokenRecaudo,
                                method: "post",
                                data: { dominio: config.urlDominioWom }
                            }).then(function (data) {
                                if (data.data.success === true) {
                                    obj.result = true;
                                    obj.token = data.data.data.token;
                                    sessionStorage.setItem('token', obj.token);
                                    obj.message = "Token generado con éxito";
                                }
                                else {
                                    obj.result = false;
                                    obj.token = '';
                                    obj.message = "Token no generado.";
                                }
                            }).catch(function (e) {
                                obj.result = false;
                                obj.token = '';
                                obj.message = "Error generando token.";
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        obj.result = false;
                        obj.token = '';
                        obj.message = "Error intentando generar token.";
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, obj];
                }
            });
        });
    };
    DataService.prototype.getInvoices = function (serviceNumber, token, recaptchaToken) {
        return __awaiter(this, void 0, void 0, function () {
            var obj, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        obj = { result: false };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios({
                                method: 'post',
                                url: config.urlConsultaFacturas,
                                data: {
                                    "consulta": [
                                        {
                                            "parametro": "serviceNumber",
                                            "value": serviceNumber
                                        }
                                    ],
                                    "dominio": config.urlDominioWomRecaudo
                                },
                                headers: {
                                    "Accept": "application/json",
                                    "Content-Type": "application/json",
                                    "Authorization": "Bearer " + token,
                                    "X-Api-Key": recaptchaToken
                                }
                            }).then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                                var facturas;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(resp.status === 200)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, resp.data.data];
                                        case 1:
                                            facturas = (_a.sent()).facturas;
                                            if (facturas) {
                                                obj.facturas = facturas || [];
                                                obj.result = true;
                                                obj.message = 'Facturas consultadas con éxito';
                                            }
                                            else {
                                                obj.result = false;
                                                obj.message = 'Consultó y no encontró facturas.';
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            obj.result = false;
                                            obj.message = 'Error consultando facturas';
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function (e) {
                                obj.result = false;
                                obj.message = 'Error intentando consultar facturas';
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        obj.result = false;
                        obj.message = 'Error intentando consultar facturas';
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, obj];
                }
            });
        });
    };
    DataService.prototype.getTransactionInfo = function (refPayco) {
        return __awaiter(this, void 0, void 0, function () {
            var obj, e_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        obj = { result: false };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios({
                                method: 'get',
                                url: config.urlTransaccionInfo + '/' + refPayco
                            }).then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                                var data;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!resp.data.success) return [3 /*break*/, 2];
                                            return [4 /*yield*/, resp.data];
                                        case 1:
                                            data = (_a.sent()).data;
                                            if (data) {
                                                obj.transaccion = data;
                                                obj.result = true;
                                                obj.message = 'Transacción consultada con éxito';
                                            }
                                            else {
                                                obj.result = false;
                                                obj.message = 'Consultó y no encontró transacción.';
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            obj.result = false;
                                            obj.message = 'Error consultando transacción';
                                            _a.label = 3;
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function (e) {
                                obj.result = false;
                                obj.message = 'Error intentando consultar la transacción';
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        obj.result = false;
                        obj.message = 'Error intentando consultar la transacción';
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, obj];
                }
            });
        });
    };
    return DataService;
}());
export { DataService };
var parseJwt = function (token) {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    }
    catch (e) {
        return null;
    }
};
